/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AgentDeploymentStatus } from './agent-deployment-status';
// May contain unused imports in some cases
// @ts-ignore
import type { CachingSummary } from './caching-summary';
// May contain unused imports in some cases
// @ts-ignore
import type { CloudDetails } from './cloud-details';
// May contain unused imports in some cases
// @ts-ignore
import type { ClusterMember } from './cluster-member';
// May contain unused imports in some cases
// @ts-ignore
import type { ComponentChartVersions } from './component-chart-versions';
// May contain unused imports in some cases
// @ts-ignore
import type { ConnectionsSummary } from './connections-summary';
// May contain unused imports in some cases
// @ts-ignore
import type { Database } from './database';
// May contain unused imports in some cases
// @ts-ignore
import type { Endpoint } from './endpoint';
// May contain unused imports in some cases
// @ts-ignore
import type { Features } from './features';
// May contain unused imports in some cases
// @ts-ignore
import type { ProxyDeploymentStatus } from './proxy-deployment-status';
// May contain unused imports in some cases
// @ts-ignore
import type { RecommendationsSummary } from './recommendations-summary';

/**
 * A database instance that the db-proxy can connect to
 * @export
 * @interface DatabaseInstance
 */
export interface DatabaseInstance {
    /**
     * Chart versions of the DBO agent deployment on the database instance.
     * @type {ComponentChartVersions}
     * @memberof DatabaseInstance
     */
    'agentChartVersions'?: ComponentChartVersions;
    /**
     * Deployment status of the db-agent on the database instance.  Absent when no agent is deployed.
     * @type {AgentDeploymentStatus}
     * @memberof DatabaseInstance
     */
    'agentDeploymentStatus'?: AgentDeploymentStatus;
    /**
     * Status of the DBO agent deployment on the database instance.
     * @type {string}
     * @memberof DatabaseInstance
     */
    'agentStatus'?: DatabaseInstanceAgentStatusEnum;
    /**
     * Cache group identifier linked to this database instance
     * @type {string}
     * @memberof DatabaseInstance
     */
    'cacheGroupId'?: string;
    /**
     * Caching related stats summary
     * @type {CachingSummary}
     * @memberof DatabaseInstance
     */
    'cachingSummary'?: CachingSummary;
    /**
     * Cloud provider details. Absent for manually created instances.
     * @type {CloudDetails}
     * @memberof DatabaseInstance
     */
    'cloudDetails'?: CloudDetails;
    /**
     * Connections stats summary
     * @type {ConnectionsSummary}
     * @memberof DatabaseInstance
     */
    'connectionsSummary'?: ConnectionsSummary;
    /**
     * When the database instance was created
     * @type {string}
     * @memberof DatabaseInstance
     */
    'createTime'?: string;
    /**
     * Logical databases with per-database summary statistics. Populated by GetDatabaseInstance.
     * @type {Array<Database>}
     * @memberof DatabaseInstance
     */
    'databases'?: Array<Database>;
    /**
     * db-proxy ID
     * @type {string}
     * @memberof DatabaseInstance
     */
    'dbProxyId'?: string;
    /**
     * List of upstream database endpoints
     * @type {Array<Endpoint>}
     * @memberof DatabaseInstance
     */
    'endpoints': Array<Endpoint>;
    /**
     * Features enabled for the database instance.
     * @type {Features}
     * @memberof DatabaseInstance
     */
    'features'?: Features;
    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstance
     */
    'id'?: string;
    /**
     * Member nodes of the cluster. Only populated by GetDatabaseInstanceDetails  for cloud-synced cluster instances; empty otherwise. Members carry  configuration only — use ListDatabaseInstanceMembers for their metrics.
     * @type {Array<ClusterMember>}
     * @memberof DatabaseInstance
     */
    'members'?: Array<ClusterMember>;
    /**
     * Name of the database instance
     * @type {string}
     * @memberof DatabaseInstance
     */
    'name': string;
    /**
     * Protocol of the database instance
     * @type {string}
     * @memberof DatabaseInstance
     */
    'protocol': DatabaseInstanceProtocolEnum;
    /**
     * Chart versions of the DBO proxy deployment on the database instance.
     * @type {ComponentChartVersions}
     * @memberof DatabaseInstance
     */
    'proxyChartVersions'?: ComponentChartVersions;
    /**
     * Deployment status of the db-proxy on the database instance, including  whether the proxy must be redeployed to pick up endpoint changes.  Absent when no proxy is deployed.
     * @type {ProxyDeploymentStatus}
     * @memberof DatabaseInstance
     */
    'proxyDeploymentStatus'?: ProxyDeploymentStatus;
    /**
     * Status of the DBO proxy deployment on the database instance.
     * @type {string}
     * @memberof DatabaseInstance
     */
    'proxyStatus'?: DatabaseInstanceProxyStatusEnum;
    /**
     * Recommendations stats summary
     * @type {RecommendationsSummary}
     * @memberof DatabaseInstance
     */
    'recommendationsSummary'?: RecommendationsSummary;
    /**
     * Type of the database instance (standalone or cluster).
     * @type {string}
     * @memberof DatabaseInstance
     */
    'type'?: DatabaseInstanceTypeEnum;
}

export const DatabaseInstanceAgentStatusEnum = {
    STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
    UNDEPLOYED: 'UNDEPLOYED',
    ERROR: 'ERROR',
    READY: 'READY',
    CONNECTED: 'CONNECTED'
} as const;

export type DatabaseInstanceAgentStatusEnum = typeof DatabaseInstanceAgentStatusEnum[keyof typeof DatabaseInstanceAgentStatusEnum];
export const DatabaseInstanceProtocolEnum = {
    PROTOCOL_UNSPECIFIED: 'PROTOCOL_UNSPECIFIED',
    POSTGRESQL: 'POSTGRESQL',
    MYSQL: 'MYSQL',
    ORACLE: 'ORACLE'
} as const;

export type DatabaseInstanceProtocolEnum = typeof DatabaseInstanceProtocolEnum[keyof typeof DatabaseInstanceProtocolEnum];
export const DatabaseInstanceProxyStatusEnum = {
    STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
    UNDEPLOYED: 'UNDEPLOYED',
    ERROR: 'ERROR',
    READY: 'READY',
    CONNECTED: 'CONNECTED'
} as const;

export type DatabaseInstanceProxyStatusEnum = typeof DatabaseInstanceProxyStatusEnum[keyof typeof DatabaseInstanceProxyStatusEnum];
export const DatabaseInstanceTypeEnum = {
    DATABASE_INSTANCE_TYPE_UNSPECIFIED: 'DATABASE_INSTANCE_TYPE_UNSPECIFIED',
    STANDALONE: 'STANDALONE',
    CLUSTER: 'CLUSTER'
} as const;

export type DatabaseInstanceTypeEnum = typeof DatabaseInstanceTypeEnum[keyof typeof DatabaseInstanceTypeEnum];


